<script lang="ts">
  import { TodayTasks } from "../../../utils/Constant/Constant";
  import TasksCommenTab from "./TasksCommenTab.svelte";
</script>

<TasksCommenTab tasksName={TodayTasks} tabId={"pills-todaytask"} />
